import headerStyles from './HeaderStyles';
import { retailerSettingsService } from '../../../services/retailer-settings/retailer-settings';

class HeaderController {
  constructor() {
    this.headerStyle = retailerSettingsService.getHeaderStyle();
    this.s = headerStyles[this.headerStyle];
    this.header = retailerSettingsService.getHeader();
    this.banner = retailerSettingsService.getBanner();
    this.nav = retailerSettingsService.getNav();
  }
}

export default HeaderController;
